import gql from 'graphql-tag';
import { vehicleMakeModelQuery } from 'next-common';

export const queryVehicleMakeModel = gql`
  ${vehicleMakeModelQuery}
`;
